import { Button, Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CloseOutlined } from "@/icons"
import { Form } from "@/organisms/Form"
import { getDestinationError } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"
import { PlatformField } from "@/pages/GovernancePage/components/organisms/LiveRuleField/PlatformField"
import { DestinationInput } from "./DestinationInput"

import styles from "./RuleField.module.scss"

import type { Rule } from "@/atoms"
import type { AiPolicyFormDestination } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/AiPolicyForm/AiPolicyForm.types"
import type { DestinationsFieldProps } from "./RuleField.types"

const NEW_DESTINATION: AiPolicyFormDestination = {}

// The destinations a network destination condition denies, one at least:
// removing the last removes the condition, where it can go; where it cannot,
// the last has no remove. The Kodem sensor alone enforces them
export const DestinationsField = (props: DestinationsFieldProps) => {
  const { name, onChange, onRemoveLast } = props
  const { t } = useTranslation()
  const destinationRules: Rule[] = [
    {
      validator: async (_, destination?: AiPolicyFormDestination) => {
        const error = getDestinationError(t, destination ?? {})

        if (error) throw new Error(error)
      }
    }
  ]

  return (
    <Flex vertical gap={8} className={styles.f1}>
      <Form.List name={[name, "destinations"]} initialValue={[NEW_DESTINATION]}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name: index }) => (
              <Flex key={key} gap={8} align="start">
                <Form.Item
                  name={index}
                  className={styles.f1}
                  rules={destinationRules}
                >
                  <DestinationInput onChange={onChange} />
                </Form.Item>
                {fields.length === 1 && !onRemoveLast ? (
                  <span className={styles.removeSpace} />
                ) : (
                  <Button
                    type="text"
                    icon={
                      <Text type="secondary" className="sm-text-ks">
                        <CloseOutlined />
                      </Text>
                    }
                    onClick={() =>
                      fields.length === 1 ? onRemoveLast?.() : remove(index)
                    }
                  />
                )}
              </Flex>
            ))}
            <span>
              <Button
                type="link"
                size="small"
                className={styles.buttonP0}
                onClick={() => add(NEW_DESTINATION)}
              >
                {t("governance.ai.live.form.destinations.add")}
              </Button>
            </span>
          </>
        )}
      </Form.List>
      <PlatformField name={name} />
    </Flex>
  )
}
